export function isLikelyStoredMediaObjectKey(value: string): boolean {
  const t = value.trim();
  if (!t) return false;
  if (t.startsWith('http://') || t.startsWith('https://') || t.startsWith('/api/') || t.startsWith('data:') || t.startsWith('blob:')) {
    return false;
  }
  return t.includes('/');
}

export function mediaRefResolvesToObjectKey(raw: string, targetKey: string): boolean {
  const t = raw.trim();
  if (!t || !targetKey) return false;
  if (t === targetKey) return true;
  if (t.startsWith('http://') || t.startsWith('https://')) {
    try {
      const u = new URL(t);
      if (!u.pathname.includes('api/media/object')) return false;
      const k = u.searchParams.get('key');
      if (!k) return false;
      return decodeKeyParam(k) === targetKey;
    } catch {
      return false;
    }
  }
  if (t.includes('/api/media/object')) {
    try {
      const href = t.startsWith('/') ? `https://placeholder.invalid${t}` : new URL(t, 'https://placeholder.invalid').href;
      const u = new URL(href);
      const k = u.searchParams.get('key');
      if (!k) return false;
      return decodeKeyParam(k) === targetKey;
    } catch {
      return false;
    }
  }
  return false;
}

function decodeKeyParam(k: string): string {
  try {
    return decodeURIComponent(k);
  } catch {
    return k;
  }
}
